/**
 * Report Free Text Template
 * Template structure for new shift reports with pre-filled section headings
 */

export const FREE_TEXT_TEMPLATE = `Kort beskrivelse av skiftet:


Ukeoppgaver gjort:


Beskjeder til neste skift:`;
